<template>
  <div>

    <d-container fluid class="main-content-container px-4">

      <!-- Page Header -->
      <div v-if="!validPlans" style="padding: 15px;">
        Você precisa ter um plano ativo para poder ver o conteúdo dessa página.
      </div>
      <div v-if="validPlans" style="padding-top: 20px;">
        <div style="text-align: left;padding: 10px; border: dashed 1px rgb(220, 220, 220); background-color: white;">
          <div v-if="magazine.photo" style="display: inline-block;">
            <img :src="magazine.photo" style="max-width:100%; max-height: 150px;border-radius: 5px;" />
          </div>
          <div style="display: inline-block; padding-left: 10px; vertical-align: top;">
            <h3 class="page-title">{{magazine ? magazine.name : ''}}</h3>
            <div v-html="magazine ? magazine.description : ''" style="padding-bottom: 10px;"></div>
          </div>
        </div><br/>
        <div style="padding-bottom: 10px;">
          <h3>Arquivos para download</h3>
        </div>
        <d-row>
          <d-col v-for="(post, idx) in magazine.itens" :key="idx" lg="3" md="6" sm="12" class="mb-4">
            <a :href="post.url" target="_blank" style="text-decoration: none;">
              <div class="download-file">
                <i class="material-icons iconDownload">insert_drive_file</i>
                <div class="download-text">
                  <b>{{post.title}}</b><br/>
                  <span style="font-weight: normal;">{{post.description}}</span>
                </div>
              </div>
            </a>
          </d-col>
        </d-row>
      </div>
    </d-container>
  </div>
</template>
<script>
import axios from 'axios'
import config from '../config/index'
import {setCookie, getCookie} from '../utils'
export default {
  name: 'magazine-details-view',
  data() {
    return {
      magazine: null,
      validPlans: true
    };
  },
  beforeMount(){
    this.getCurrentPlans();
  },
  methods: {
    getCurrentPlans() {
      axios.get(config.serverUrl + '/v1/showCurrentPlan', {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        if (res.data.response && res.data.subscriptions.length > 0) {
          this.getData()
        } else {
          // this.validPlans = false
          this.getData()
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    getData() {
      axios.get(config.serverUrl + '/v1/magazine/' + this.$route.params.magazineId, {
        headers: {
          Authorization: getCookie('token-client')
        }
      })
      .then((res) => {
        if (res.data.response) {
          this.magazine = res.data.magazine
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
  }
};
</script>